// dashbaord
import Social from "../Components/Dashboard/Social";
import ErrorPage4 from '../Components/Pages/ErrorPages/ErrorPage404';
import Category from "../Pages/Category";
import Insight from "../Pages/Insight";
import Language from "../Pages/Language";
import Leadership from "../Pages/Leadership";
import News from "../Pages/News";
import Stream from "../Pages/Stream";
import Teams from "../Pages/Teams";

export const routes = [
  { path: `/dashboard/:layout`, Component: <Social /> },


  { path: `/news/:layout`, Component: <News /> },
  { path: `/insights/:layout`, Component: <Insight /> },
  { path: `/teams/:layout`, Component: <Teams /> },
  { path: `/leadership/:layout`, Component: <Leadership /> },


  // { path: `/stream/:layout`, Component: <Stream /> },
  // { path: `/category/:layout`, Component: <Category /> },
  // { path: `/language/:layout`, Component: <Language /> },


  //Error
  { path: `*`, Component: <ErrorPage4 /> },

];
